<template>
  <div
    class="iframe-container"
    style="background-color: #1f4e78;"
  >
    <iframe
      width="100%"
      height="2000"
      src="https://www.youtube.com/embed/muWzRWwFY84"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      style="border-radius: 0.5%"
    ></iframe>
  </div>
</template>

<script>
export default {
  created() {
    // Scroll the window to top on load
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
};
</script>

<style>
/* https://www.youtube.com/watch?v=9YffrCViTVk&ab_channel=tipswithpunch */
.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}
.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/demovideos/DemoVideoHousehold.vue